<template>
  <span
    class="icon"
    :class="{ 'icon--fill': !filled }"
    :data-name="name"
    v-html="icon"
  />
</template>

<script setup>
import { getIcon } from '@attendu/icons';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  filled: {
    type: Boolean,
    default: false,
  },
});

// Refs
const icon = ref('');

// Watchers
watchEffect(async() => {
  try {
    icon.value = await getIcon(props.name);
  } catch {
    console.error(
      `Icon '${props.name}' doesn't exist in 'assets/icons'`,
    );
  }
});

if (import.meta.server && props.name) {
  icon.value = await getIcon(props.name); // for SSR
}
</script>

<style>
.icon {
  @apply w-5 h-5 inline-flex items-center justify-center;
}

.icon svg {
  width: 100%;
  height: auto;
}

.icon.icon--fill > :not(.custom-color),
.icon.icon--fill > :not(.custom-color) * {
  fill: currentColor !important;
}
</style>
